import { Navigate, useLocation } from "react-router-dom";
import { getAdminUser } from "../utils/auth";

const RoleRoute = ({ allow, children }) => {
  const location = useLocation();
  const user = getAdminUser();

  if (!allow(user?.role)) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default RoleRoute;
